<template>
    <div class="multiple-choice-question-section d-flex">
        <div class="question-text d-flex">
            <span class="primary-text">{{ this.data.title }}</span>
            <span class="secondary-text">{{ this.data.description }}</span>
        </div>
        <MultipleChoiceComponent
            :options="this.data.options"
            @update-selection="updateSelection($event)"
        />
    </div>
</template>

<script>
    import MultipleChoiceComponent from '../form-components/MultipleChoiceComponent.vue';

    export default {
        name: 'GeneralMultipleChoiceQuestion',
        components: { MultipleChoiceComponent },

        props: {
            data: {
                type: Object,
                required: true,
            },
        },

        methods: {
            updateSelection(value) {
                this.$emit('update-form', value);
            },
        },
    };
</script>
